import React, { useState, useEffect } from 'react';
import SubmenuList from './SubmenuList';
import HowToUse from './HowToUse';
import Howtousenew from './Howtousenew';
import FooterControl from './FooterControls';
import ReactDOM from 'react-dom';
import Features from './Features';
const Menu = () => {
   const [myJson, setMyJson] = useState([]);
   const [menuList, setMenuList] = useState([]);
   const [featureMenuList, setfeatureMenuList] = useState([]);
   const [openCloseOnOff, setOpenCloseOnOff] = useState(false);
   const [backliteOnOff, setBackliteOnOff] = useState(false);
   const [languageUpd,setlanguageUpd] = useState(window.LangName);

   const [buttonArray, setbuttonArray] = useState([]);
   const [buttonArrayObjectList, setbuttonArrayObjectList] = useState([]);
   const [widthUpdate, setwidthUpdate] = useState(false);
   const [uiDataList, setuiDataList] = useState({});
   // setwidthUpdate(window.mob)
   let howtoUseD = false;
   var mob = (navigator.userAgent.indexOf("iPhone") != -1) || ((navigator.userAgent.indexOf("Android") != -1) || (navigator.userAgent.indexOf("Mobile") != -1)) || (navigator.userAgent.indexOf('iPod') != -1) || (navigator.userAgent.indexOf('iPad') != -1) || (navigator.userAgent == "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/13.0.1 Safari/605.1.15");
   const getData = () => {
      fetch('data.json'
         , {
            headers: {
               'Content-Type': 'application/json',
               'Accept': 'application/json'
            }
         }
      )
         .then(function (response) {
            return response.json();
         })
         .then(function (mydata) {
            return mydata;

         }).then(function (setmydata) {
            setMyJson(setmydata);
            document.title = setmydata.ProjectTitle;
            window.ProjectTitle = setmydata.ProjectTitle;

            let feature_list;
            let menuData;

            let uiData;

             if (setmydata.menus[window.LangName] == undefined) {
               uiData = setmydata.menus.EN[0];
               // alert('if');
             } else {
               uiData = setmydata.menus[window.LangName][0];
               // alert('else');
             }
            window.dataUI = uiData;


            if (window.LangName && window.LangName in setmydata['menus'] && setmydata.LangugageTranslation) {

               // TowerClick(setmydata.menus[window.LangName].filter(val => val.featureMenu === false));
               menuData = setmydata.menus[window.LangName].filter(val => val.featureMenu === false && val.menuVisibility !== 'hide');

               if ((window.mob || window.isipad) && window.innerWidth < window.innerHeight) {
                  menuData = setmydata.menus[window.LangName].filter(val => val.featureMenu === false && val.menuVisibility !== 'hide');
                  // productTypeData = setmydata.menus[window.LangName].filter(val => val.menuVisibility !== 'hide' && val.id === "ProductType");
               }

            }
            else {
               // console.log("Language Not Found setting default language.")
               menuData = setmydata.menus.EN.filter(val => val.featureMenu === false && val.menuVisibility !== 'hide')

            }

            // code to set menu in ipad and mobile
            // if ((window.mob || window.isipad) && window.innerWidth < window.innerHeight) {
            //    // console.log("mobile & ipad potrait menu set");
            //    menuData = setmydata.menus.EN.filter(val => val.featureMenu === false && val.menuVisibility !== 'hide' && val.id != "ProductType")
            // }






            // console.log("uiData ======",uiData)
            // console.log("++++",uiData.ui)
            // console.log(window.LangName in setmydata['menus'],setmydata.LangugageTranslation)
            // if (window.LangName && window.LangName in setmydata['menus'] && setmydata.LangugageTranslation) {

            //    // console.log('if 61')
            //     TowerClick(setmydata.menus[window.LangName].filter(val => val.featureMenu === false));
            //    menuData = setmydata.menus[window.LangName].filter(val => val.featureMenu === false && val.menuVisibility !== 'hide');
            //    // uiData = setmydata.menus[window.LangName].filter(val => val.featureMenu === false && val.menuVisibility !== 'hide');

            //    feature_list = setmydata.menus[window.LangName].filter(val => val.featureMenu === true && val.menuVisibility !== 'hide');
            // }
            // else {
            //    // console.warn("Language Not Found setting default language.")
            //    // }
            //    menuData = setmydata.menus.EN.filter(val => val.featureMenu === false && val.menuVisibility !== 'hide')
            //    // selectedMenu= menuData;
            //    var mobProducts = menuData[0].items;
            //    // console.log(menuData)
            //    feature_list = setmydata.menus.EN.filter(val => val.featureMenu === true && val.menuVisibility !== 'hide');
            // }

            


            setMenuList(menuData);

            setuiDataList(uiData);

            setfeatureMenuList(feature_list)
            langTranslationAlignment(menuData);
            menuData.map((menu) => {
               menu.items.map(item => {
                  if (item.id !== undefined) {
                     setbuttonArray((buttonArray) => [...buttonArray, item.id]);

                     setbuttonArrayObjectList((buttonArrayObjectList) => [...buttonArrayObjectList, item]);
                  }
               })
            })
         });
   }
// --------------
   const langTranslationAlignment = (menuData) => {
      if (window.dataUI) {

         
setTimeout(()=>{
   // console.log(window.dataUI.ui.langcode)

   document.querySelector('title').innerHTML = window.dataUI.ui.projectTitle;
   document.getElementById('move_text').innerHTML = window.dataUI.ui.move;
   document.getElementById('rotate_text').innerHTML = window.dataUI.ui.rotate;
   document.getElementById('zoom_text').innerHTML = window.dataUI.ui.zoom;
   document.getElementById('exploreButtton').innerHTML = window.dataUI.ui.exploreProductIn3D;
   if (document.getElementById('exploreButtton1')) {
      document.getElementById('exploreButtton1').innerHTML = window.dataUI.ui.returnTo3D;

   }
},100)
         if (window.dataUI.ui.langcode == "fr") {
            document.getElementById("loading").style.width = '48%';
             
          
         }
        
         if (window.dataUI.ui.langcode == "hu" || window.dataUI.ui.langcode == "it") {
            document.getElementById("previousView").style.fontSize = '11px';
            document.getElementById("resetView").style.fontSize = '11px';
            document.getElementById("nextView").style.fontSize = '11px';
         }
         if (window.dataUI.ui.langcode == "fr-ca") {
            setTimeout(function () {
               document.getElementById("previousView").style.fontSize = '11px';
               document.getElementById("resetView").style.fontSize = '11px';
               document.getElementById("nextView").style.fontSize = '11px';
               document.getElementById("previousView").style.lineHeight = '12px';
            },0)
         }
         
         if (window.dataUI.ui.langcode == "nl") {
            document.getElementById("previousView").style.fontSize = '11px';
            document.getElementById("resetView").style.fontSize = '11px';
            document.getElementById("nextView").style.fontSize = '11px';

         }
         if (window.dataUI.ui.langcode == "es") {
            document.getElementById("loading").style.width = '71%';
            document.getElementById("previousView").style.fontSize = '13px';
            document.getElementById("resetView").style.fontSize = '13px';
            document.getElementById("nextView").style.fontSize = '13px';
            document.getElementById("zoom").style.fontSize = '39px';
            document.getElementById("mobHowToUseText").style.fontSize = '30px';
            document.getElementById("move_how_to_use").style.fontSize = '21px';
            document.getElementById("rotate_how_to_use").style.fontSize = '21px';
            document.getElementById("zoom_how_to_use").style.fontSize = '21px';
            document.getElementById("closeBtn").style.top = '3px';
            document.getElementById("closeBtn").style.right = '2px';

            // document.querySelector(".closeUseMob").style.position = 'absolute';
           // document.querySelector("#howToUSE .closeUseMob").style.top = '-11% !important';
        
            
            // document.getElementById("zoom").style.wordBreak="break-all";

            // document.getElementById("zoom").style.width = '150px';style.wordBreak="break-all";
            

         }
         if (window.dataUI.ui.langcode == "pt-br") {
            // document.querySelector("#nextViewImg").style.paddingLeft = '3px';
            document.querySelector("#resetView").style.lineHeight = '12px';
            document.querySelector("#previousView").style.textAlign = 'right';
            document.querySelector("#nextView").style.textAlign = 'left';
            document.querySelector("#nextView").style.lineHeight = '12px';
            // document.querySelector("#nextViewImg").style.Left = '529px';
            // document.querySelector("#nextViewImg").style.position = 'absolute';
            // document.querySelector("#nextViewImg").style.top = '70px';
            document.getElementById("previousView").style.fontSize = '11px';
            document.getElementById("resetView").style.fontSize = '12px';
            document.getElementById("nextView").style.fontSize = '12px';
         }
         if (window.dataUI.ui.langcode.toLowerCase() ===  "sv") {
            document.getElementById("nextViewImg").style.paddingLeft = '0px';
            document.getElementById("previousView").style.fontSize = '13px';


         }
         if (window.dataUI.ui.langcode.toLowerCase() === "de" || window.dataUI.ui.langcode == "pt-br") {
            // document.querySelector("#nextViewImg").style.paddingLeft = '3px';
            document.querySelector("#resetView").style.lineHeight = '12px';
            document.querySelector("#previousView").style.textAlign = 'right';
            document.querySelector("#nextView").style.textAlign = 'left';
            document.querySelector("#nextView").style.lineHeight = '12px';
            // document.querySelector("#nextViewImg").style.Left = '529px';
            // document.querySelector("#nextViewImg").style.position = 'absolute';
            // document.querySelector("#nextViewImg").style.top = '70px';
            document.getElementById("previousView").style.fontSize = '12px';
            document.getElementById("resetView").style.fontSize = '12px';
            document.getElementById("nextView").style.fontSize = '12px';
            document.querySelector(".tooltiptext").style.width = '306px';
         }
         if (window.dataUI.ui.langcode.toLowerCase() === "ja") {
           
            document.querySelector(".tooltiptext").style.width = '306px';
            document.querySelector(".tooltiptext").style.top = '-19px';
         }
         if (window.dataUI.ui.langcode == "tr" || window.dataUI.ui.langcode == "cs" || window.dataUI.ui.langcode == "fi") {
            // console.log("tr")
            setTimeout(function () {
               // console.log("tr1")

               // document.querySelector("#nextViewImg").style.paddingLeft = '3px';
               document.querySelector("#resetView").style.lineHeight = '12px';
               document.querySelector("#previousView").style.textAlign = 'right';
               document.querySelector("#nextView").style.textAlign = 'left';
               document.querySelector("#nextView").style.lineHeight = '12px';
               // document.querySelector("#nextViewImg").style.Left = '529px';
               // document.querySelector("#nextViewImg").style.position = 'absolute';
               // document.querySelector("#nextViewImg").style.top = '70px';
               document.getElementById("previousView").style.fontSize = '12px';
               document.getElementById("previousView").style.width = '163px';
               document.getElementById("resetView").style.fontSize = '12px';
               document.getElementById("nextView").style.fontSize = '12px';
               },0);
         }
         
         if (window.dataUI.ui.langcode == "hu" || window.dataUI.ui.langcode == "ru" || window.dataUI.ui.langcode == "da") {
            // document.getElementById("previousViewImg").style.paddingRight = '6px';
            document.querySelector(".portraitButtonText").style.fontSize = '12px';
           
         }

         if(window.dataUI.ui.langcode == "fr-ca" || window.dataUI.ui.langcode == "fr"){
            document.querySelector(".moveHowTouse").style.fontSize = '22px';
            document.querySelector(".zoomHowTouse").style.fontSize = '22px';
            document.querySelector(".rotateHowTouse").style.fontSize = '22px';
         }


         // if(window.dataUI.ui.langcode == "ru"){
         //    // ports_popup3

         //    if(window.isipad && window.innerHeight < window.innerWidth){
         //       // alert('277')
         //       if(document.getElementById("ports_popup3")!=null) document.getElementById("ports_popup3").style.left = '72%';
         //       // document.getElementById("closeBtn").style.top
         //       if(document.getElementById("ports_popup3")!=null) document.getElementById("ports_popup3").style.top = '58.4%';
         //    }

           
         // }
       
         if (window.dataUI.ui.langcode == "hu" || window.dataUI.ui.langcode == "ru" || window.dataUI.ui.langcode == "tr" || window.dataUI.ui.langcode == "it") {
            
            if(mob){
               document.querySelector("#move_text").style.lineBreak = 'anywhere';
               document.querySelector("#move_text").style.lineHeight = '55px';
            document.querySelector("#zoom_text").style.lineBreak = 'anywhere';
            document.querySelector("#zoom_text").style.lineHeight = '55px';
            }
         }
         if (window.dataUI.ui.langcode == "sk" || window.dataUI.ui.langcode == "el") {
            setTimeout(function () {
               // document.querySelector("#resetView").style.lineHeight = '12px';
               
               document.getElementById("resetView").style.fontSize = '12px';               

               // document.querySelector("#nextViewImg").style.paddingLeft = '3px';
               document.querySelector("#nextView").style.textAlign = 'left';
               // document.querySelector("#nextView").style.lineHeight = '12px';
               // document.querySelector("#nextViewImg").style.Left = '529px';
               // document.querySelector("#nextViewImg").style.position = 'absolute';
               // document.querySelector("#nextViewImg").style.top = '70px';
               document.getElementById("nextView").style.fontSize = '12px';

               document.querySelector("#previousView").style.lineHeight = '4px';
               document.getElementById("previousView").style.fontSize = '12px';
               document.querySelector("#previousView").style.textAlign = 'right';
               // document.querySelector("#previousViewImg").style.paddingRight = '1px';
               document.querySelector(".tooltiptext").style.width = '306px';

               document.querySelector("#nextView").style.width = '166px';

               
            },0);
         }
         if (window.dataUI.ui.langcode.toLowerCase() === "ru") {
               document.querySelector(".tooltiptext").style.width = '285px';  
            }

         if (mob && window.innerHeight > window.innerWidth || window.isipad && window.innerHeight > window.innerWidth) {
         setTimeout(() => {
   if (document.getElementById('exploreButtton1') !== null) {
      document.getElementById('exploreButtton1').innerHTML = window.dataUI.ui.returnTo3D;
   }
   if (document.getElementById('mobHowToUseText') !== null) {
      document.getElementById("mobHowToUseText").innerHTML = window.dataUI.ui.howToUSE;
   }
}, 100);
            
            if (window.dataUI.ui.langcode.toLowerCase() === "ro" || window.dataUI.ui.langcode.toLowerCase() === "it") {
               setTimeout(function () {
                  document.querySelector("#mobHowToUseText").style.fontSize = '33px';
               },0);

            }

           
            if (window.dataUI.ui.langcode.toLowerCase() === "ru") {
               setTimeout(function () {
                  document.querySelector("#mobHowToUseText").style.fontSize = '32px';
                  document.querySelector("#mobHowToUseText").style.lineHeight = '38px';
                  document.querySelector("#howToUseMenu.text").style.fontSize = '15px';
                 
                  
                 
               },0);

            }
            if (window.dataUI.ui.langcode.toLowerCase() === "ro") {
               setTimeout(function () {
                  document.getElementById("#nextView").style.fontSize = '12px';
                 
               },0);

            }
            if (window.dataUI.ui.langcode.toLowerCase() === "pl") {
               setTimeout(function () {
                  document.querySelector("#mobHowToUseText").style.top = '-16%';

               },0);

            }
         }

         if (window.dataUI.ui.langcode.toLowerCase() === "fr-ca") {
            setTimeout(function () {
               document.querySelector("#rotate_text").style.width = '265px';
               document.querySelector("#rotate_text").style.display = 'inline-block';
            },0);

         }
         if (window.dataUI.ui.langcode.toLowerCase() === "no" ){
           
            // document.querySelector("#accordion_adjustability .text").style.wordBreak="break-all";
            // document.querySelector("#accordion_adjustability .text").style.marginRight="10px";
            
         }
         
         if (window.dataUI.ui.langcode.toLowerCase() === "nl" || window.dataUI.ui.langcode.toLowerCase() === "ru" || window.dataUI.ui.langcode.toLowerCase() === "hu" || window.dataUI.ui.langcode.toLowerCase() === "ro") {
            setTimeout(function () {
               document.querySelector("#previousView").style.lineHeight = '12px';
               document.querySelector("#resetView").style.lineHeight = '12px';
               document.querySelector("#nextView").style.lineHeight = '12px';
               document.querySelector("#previousView").style.textAlign = 'right';
               document.querySelector("#nextView").style.textAlign = 'left';
              
               // document.querySelector("#nextView").style.lineHeight = '15px';
               // document.querySelector("#nextView").style.display = "inline-flex"
               // document.querySelector("#previousView").style.lineHeight = '15px';
               // document.querySelector("#previousView").style.display = "inline-flex"
            },0);
         }
         if (window.dataUI.ui.langcode.toLowerCase() === "ru" || window.dataUI.ui.langcode.toLowerCase() === "ro"){
            document.querySelector("#previousView").style.top = '-6px';
            document.querySelector("#nextView").style.top = '-10px';
         }
        
         if (window.dataUI.ui.langcode.toLowerCase() === "pl") {
            setTimeout(function () {
               document.querySelector("#previousView").style.fontSize = '11px';
               document.querySelector("#resetView").style.fontSize = '12px';
               document.querySelector("#nextView").style.fontSize = '12px';
               document.querySelector("#previousView").style.textAlign = 'right';
               document.querySelector("#nextView").style.textAlign = 'left';
            },0);

         }
         if (window.isipad && window.innerHeight < window.innerWidth) {
         if (window.dataUI.ui.langcode === "de" || window.dataUI.ui.langcode === "da" || window.dataUI.ui.langcode === "fr" || window.dataUI.ui.langcode === "fr-ca" || window.dataUI.ui.langcode === "no") {
            document.querySelector("#previousView").style.width = '164px';
            document.getElementById("#nextView").style.fontSize = '13px';
         }
         if(window.dataUI.ui.langcode === "fr") {
               document.querySelector("#previousView").style.fontSize = '13px';
               document.getElementById("#nextView").style.fontSize = '13px';  
         }
      }

      }
   }
// -----------
   useEffect(() => {

      const menuref = document.querySelector('.menuContainer');
      window.mainMenuRef = menuref;

   })

   useEffect(() => {
      setTimeout(() => {

         getData();

      }, 1000);

   }, [])

   window.checkWindowSize = function () {
      setwidthUpdate(window.mob)
   }

   const menuExpandCollaps = () => {
      var mainMenu = window.mainMenuRef;
      var mainMenuClass = mainMenu.classList;
      if (mainMenuClass.contains("collapsed")) {
         mainMenu.classList.remove('collapsed');
         mainMenu.classList.add('expanded');
      } else {
         mainMenu.classList.add('collapsed');
         mainMenu.classList.remove('expanded');
         var getExpandedAccordion = document.querySelectorAll('.menu.active');
         if (getExpandedAccordion.length !== 0) {
            for (var i = 0; i <= getExpandedAccordion.length; i++) {
               if (getExpandedAccordion[i] !== undefined) {
                  getExpandedAccordion[i].classList.remove('active');
                  getExpandedAccordion[i].nextSibling.style.height = '0px';
               }

            }
         }
      }

   }
   const howToUSEClick = (e) => {
      if (howtoUseD) {
         document.getElementById('howToUSE').style.opacity = "0";
         document.getElementById('howToUSE').style.marginTop = "-100%";
         document.getElementById('howToUSE').style.animationName = "example";
         document.getElementsByClassName('HowToUseHeader')[0].style.backgroundColor = "#FFFFFF";
         document.getElementsByClassName('HowToUseHeader')[0].lastChild.style.color = "#006BBD";
         document.getElementById('howToUseMenu').firstChild.classList.remove('active');

         howtoUseD = false;
      } else {
         document.getElementById('howToUSE').style.opacity = "1";
         if (window.isipad && window.innerWidth > window.innerHeight) {
            document.getElementById('howToUSE').style.marginTop = "2.7%";

         } else {
            document.getElementById('howToUSE').style.marginTop = "-1%";

         }
         document.getElementById('howToUSE').style.animationName = "example1";
         document.getElementsByClassName('HowToUseHeader')[0].style.backgroundColor = "#0076CE";
         document.getElementsByClassName('HowToUseHeader')[0].lastChild.style.color = "#FFFFFF";
         document.getElementById('howToUseMenu').firstChild.classList.add('active');

         howtoUseD = true;
      }
   }
   const closeHandle = (event) => {
      event && event.preventDefault();
      if (document.getElementById('howToUSE')) {
         document.getElementById('howToUSE').style.opacity = "0";
         document.getElementById('howToUSE').style.marginTop = "-100%";
         document.getElementById('howToUSE').style.animationName = "example";
         document.getElementsByClassName('HowToUseHeader')[0].style.backgroundColor = "#FFFFFF";
         document.getElementsByClassName('HowToUseHeader')[0].lastChild.style.color = "#006BBD";
         document.getElementById('howToUseMenu').firstChild.classList.remove('active');

         howtoUseD = false;
      }

   };

   const accordionMenu = (e) => {
      window.hidePopUp();
      var mainMenu = window.mainMenuRef;
      var mainMenuClass = mainMenu.classList;

      setTimeout(function () {
         var allPopup = document.querySelector('.popup.active');
         if (allPopup != null) {
            allPopup.classList.remove('active');
         }
      }, 500)

      if (mainMenuClass.contains("collapsed")) {
         mainMenu.classList.remove('collapsed');
         mainMenu.classList.add('expanded');
      }

      if (e.target.closest('.menu').classList.contains('active')) {
         if ((!window.mob && window.innerWidth > window.innerHeight)) {
            e.target.closest('.menu').classList.remove('active');
            e.target.closest('.menu').nextSibling.style.height = '0px';

         }

      }
      else {
         var menu_active = document.querySelectorAll('.menu');
         for (var i = 0; i <= menu_active.length - 1; i++) {
            if (menu_active[i].id !== 'howToUseMenu') {

               menu_active[i].classList.remove('active')
               menu_active[i].nextSibling.style.height = '0px';
            }
         }

         e.target.closest('.menu').classList.add('active');
         window.selectedButtonType = e.target.closest('.menu').id;
         var accordionContent = e.target.closest('.menu').nextSibling.firstChild;
         if (accordionContent != null) {
            e.target.closest('.menu').nextSibling.style.height = accordionContent.offsetHeight + 'px';
         }

      }

      if (orentation === 90) {

         closeHandle();
      }

      var selectedSubMenu = document.querySelectorAll('.subMenuBtn');
      for (var i = 0; i <= selectedSubMenu.length - 1; i++) {
      }
      var slider = document.getElementById("sliderRange");
      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); }, 1000);
      }
   }
   const subMenu = (e) => {

      var selectedSubMenu = document.querySelectorAll('.subMenuBtn');
      for (var i = 0; i <= selectedSubMenu.length - 1; i++) {
         selectedSubMenu[i].classList.remove('active')
      }
      e.target.classList.add('active');
   }
   var data1 = {
      method: accordionMenu,
      method2: howToUSEClick,
      method3: subMenu,
   }
   const handleTransitions = (e) => {
      const isChecked = document.getElementById("animSwitchValue").checked;

      if (isChecked === true) {
         window.Animation = 'on';

      } else {
         window.Animation = 'off';

      }

   }
   const handleTransitionskeyPress = (e) => {
      const isChecked = document.getElementById("animSwitchValue").checked;

      if (isChecked === true) {
         window.Animation = 'off';
         document.getElementById("animSwitchValue").checked = false;
      } else {
         window.Animation = 'on';
         document.getElementById("animSwitchValue").checked = true;

      }

   }
   var animStopped = true;

   const conScreenControlHandler = (e) => {

      const isChecked = document.getElementById("onScreenControlsValue").checked;
      if (isChecked === true) {
         window.animation1SwitchGlobal = 'on';
         window.animationSwitchVal = 'on';

         if (window.mob && !window.isipad) {

            document.getElementById('footerControls').removeAttribute('style');
         } else if (window.isipad) {

            if (window.innerWidth > window.innerHeight) {
               document.getElementById('footerControls').style.display = 'block';
               document.getElementById('footerControls').style.bottom = "55px";
            } else {
               document.getElementById('footerControls').style.display = 'none';
            }
         } else {

            var navBtn = document.querySelectorAll('.navBtn');
            for (var i = 0; i <= navBtn.length - 1; i++) {
               navBtn[i].setAttribute("tabindex", "2");
            }
            document.getElementById('footerControls').style.bottom = "55px";
         }


      } else {
         window.animation1SwitchGlobal = 'off';
         if (window.mob) {
            document.getElementById('footerControls').removeAttribute('style');
         } else if (window.isipad) {
            document.getElementById('footerControls').style.display = 'none';
         }
         else {
            document.getElementById('footerControls').style.bottom = "-155px";
            var navBtn = document.querySelectorAll('.navBtn');
            for (var i = 0; i <= navBtn.length - 1; i++) {
               navBtn[i].setAttribute("tabindex", "-1");
            }
            setTimeout(function () {


               animStopped = true;
            }, 200);
         }

      }

   }

   const conScreenControlHandlerkeyPress = (e) => {

      const isChecked = document.getElementById("onScreenControlsValue").checked;
      if (isChecked === false) {
         window.animation1SwitchGlobal = 'on';
         window.animationSwitchVal = 'on';

         if (window.mob) {
            document.getElementById('footerControls').removeAttribute('style');
         }
         else if (window.isipad) {
            document.getElementById('footerControls').style.display = 'block';
         }
         else {
            document.getElementById('footerControls').style.bottom = "55px";
            var navBtn = document.querySelectorAll('.navBtn');
            for (var i = 0; i <= navBtn.length - 1; i++) {
               navBtn[i].setAttribute("tabindex", "2");
            }
            document.getElementById("onScreenControlsValue").checked = true;
         }


      } else {
         window.animation1SwitchGlobal = 'off';

         if (window.mob) {
            document.getElementById('footerControls').removeAttribute('style');
         } else if (window.isipad) {
            document.getElementById('footerControls').style.display = 'none';
         }
         else {
            document.getElementById('footerControls').style.bottom = "-155px";
            document.getElementById("onScreenControlsValue").checked = false;
            var navBtn = document.querySelectorAll('.navBtn');
            for (var i = 0; i <= navBtn.length - 1; i++) {
               navBtn[i].setAttribute("tabindex", "-1");
            }
            setTimeout(function () {

               animStopped = true;
            }, 200);
         }

      }

   }
   const handleMenuClick = (menu_object, e) => {
      let cameraId = menu_object['id'];
      let cameraName = menu_object['cameraName'];
      let cameraType = menu_object['type'];
      // if (!window.AnimComplated) {
      //    return
      // }
      // var center = [0, 0, 0];
      // window.scene._nav.SetRotationCenter(center);

      window.execute_all(menu_object);
      setMenuActive(cameraId, cameraType, e);
      window.hidePopUp();
      if (orentation === 90) {
         closeHandle();
      }

   }

   const setMenuActive = (menu_id, menu_type, e) => {
      var currentActive;
      if (e != undefined) {
         currentActive = e.target.closest('li');
      } else {
         currentActive = document.getElementById('menu_id_' + menu_id);
      }

      // let currentClass = currentActive && currentActive.classList[1]
      let currentClass = currentActive.classList[0]
      let preActive = document.querySelector('.' + currentClass + '.active');
      if (preActive != null) {
         preActive.classList.remove('active');
      }

      // if ((window.mob || window.isipad) && window.innerHeight > window.innerWidth) {
      //    if (preActive?.id == currentActive?.id) {
      //       setTimeout(() => {
      //          currentActive.classList.remove('active')
      //       }, 100);
      //    } else {
      //       currentActive.classList.add('active')
      //    }
      // } else {

      //    currentActive.classList.add('active');
      // }
      
      currentActive.classList.add('active');
      window.selectedConfig.currentProductClick = currentActive.id;
      window.selectedButton = menu_id;
      window.checkedButton = menu_id;
      window.selectedButtonType = menu_type;

      var slider = document.getElementById("sliderRange");
      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); }, 1000);
      }
   }

   const onPreviousMode = () => {
      window.hidePopUp();
      // var center = [0, 0, 0];
      // window.scene._nav.SetRotationCenter(center);
      var slider = document.getElementById("sliderRange");
      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); }, 1000);
      }

      var prevButton;
      var selectedButtonIndex = buttonArray.findIndex(element => element === window.checkedButton)
      if (!window.AnimComplated) {
         return
      }
      if (window.checkedButton == 'onResetMode' || window.checkedButton == '') {
         prevButton = buttonArray[buttonArray.length - 1];
      } else {

         prevButton = buttonArray[selectedButtonIndex - 1];
      }

      if (prevButton == undefined) { prevButton = buttonArray[buttonArray.length - 1] }

      let result = buttonArrayObjectList.find(object => object.id == prevButton);
      if (window.selectedButtonType !== result['type']) {

         expandMenu(`accordion_${result['type']}`);
      }

      window.execute_all(result);
      setMenuActive(result['id'], result['type']);


      return false;

   }
   const onNextMode = () => {

      window.hidePopUp();
      // var center = [0, 0, 0];
      // window.scene._nav.SetRotationCenter(center);
      let cameraName;
      var slider = document.getElementById("sliderRange");
      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); }, 1000);
      }
      var nextButton;
      var selectedButtonIndex = buttonArray.findIndex(element => element === window.checkedButton)
      if (!window.AnimComplated) {
         return
      }
      if (window.checkedButton === 'onResetMode' || window.checkedButton === '') {
         nextButton = buttonArray[0];
      } else {
         nextButton = buttonArray[selectedButtonIndex + 1];
      }
      if (nextButton === undefined) { nextButton = buttonArray[0] }

      let result = buttonArrayObjectList.find(object => object.id === nextButton);
      if (window.selectedButtonType !== result['type']) {

         expandMenu(`accordion_${result['type']}`);
      }

      window.execute_all(result);
      setMenuActive(result['id'], result['type']);

      return false;

   }
   const onReset = () => {
      //Update ZoomBar
      window.hidePopUp();
      var slider = document.getElementById("sliderRange");
      let cameraName;
      // var center = [0, 0, 0];
      // window.scene._nav.SetRotationCenter(center);

      if (slider !== null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); }, 1000);
      }
      if (!window.AnimComplated) {
         return
      }
      let nextButton;
      if (window.checkedButton === 'onResetMode' || window.checkedButton === '') {
         window.GotoPosInTimeNamedValue(window.config.cameraReset);
      }
      else {
         nextButton = window.checkedButton;
      }

      let result = buttonArrayObjectList.find(object => object.id === nextButton);
      if (window.checkedButton !== 'onResetMode' || window.checkedButton !== '') {
         if (result !== undefined) {
            expandMenu(`accordion_${result['type']}`);
         }
      }
      if (result !== undefined) {
         window.execute_all(result);
         setMenuActive(result['id'], result['type']);
      }
   }
   const expandMenu = (menuId) => {
      if (document.querySelector('.menu.active') != null) {
         document.querySelector('.menu.active').classList.remove('active');
         var accordionContentAll = document.querySelectorAll('.accordionContent');

         for (var i = 0; i <= accordionContentAll.length - 1; i++) {
            accordionContentAll[i].style.height = '0px';
         }
      }

      var accordionContent = document.getElementById(menuId).nextSibling.firstChild;
      if (accordionContent != null) {

         document.getElementById(menuId).classList.add('active')

         document.getElementById(menuId).nextSibling.style.height = accordionContent.offsetHeight + 'px';
      }

   }
   const howToUseMobClick = () => {
      document.getElementById('howToUSE').style.display = "block";
      document.getElementById('howTousePopup').style.display = "block";
      document.getElementsByClassName('HowToUseHeader')[0].style.backgroundColor = "#0076CE";
      document.getElementsByClassName('HowToUseHeader')[0].style.color = "#FFFFFF";
      document.getElementById('howToUSE').style.zIndex = "12";
      document.getElementById('howTousePopup').style.zIndex = "2";
   }
   const [orentation, setOrentation] = useState(window.innerHeight > window.innerWidth ? 0 : 90)


   const arbuttonName = ((navigator.userAgent.indexOf("iPhone") != -1) || (navigator.userAgent.indexOf('iPad') != -1) || (navigator.userAgent.indexOf('iPod') != -1) || (navigator.userAgent == "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/13.0.1 Safari/605.1.15") || window.detectIpadDevice()) || (navigator.userAgent.match(/Mac/) && navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && (navigator.userAgent.indexOf("iPhone") == -1)) ? 'btnXR-iphone' : 'btnXR';

   const TowerClick = (menuData) => {
      // window.execute_all(menuData[0].items[0]);
   }

   //This code is for how to use component resize issue
   const CanvasResizeFunction = () => {
      if (window.innerHeight > window.innerWidth) {
         setOrentation(0)
      } else if (window.innerWidth > window.innerHeight) {
         setOrentation(90)
      } else {
         setOrentation((item) => {
            return item;
         })
      }


   }
   window.addEventListener('resize', CanvasResizeFunction)
   const { howToUSE, ReduceTransitions, onScreenControls, hovertext, QR } = { ...uiDataList.ui }
   return (
      <>
         <div className='leftMenuWrapper' id='leftMenuWrapper'>
            <div id='mainMenu' className='menuContainer expanded'>
               <div className='portraitButton' id={arbuttonName} style={arbuttonName === 'btnXR' ? { 'display': 'none' } : {}}>
                  {/* <span className='portraitButtonText'>
                  See {myJson.ProjectTitle} in your space</span> */}

                  <span className='portraitButtonText'>
                     {/* See {myJson.ProjectTitle} in your space</span> */}
                     {uiDataList.ui?.arMob}</span>

               </div>
               <div className={`howToUseMob `} id="howToUseMob" onClick={howToUseMobClick} >
                  {/* <span className='portraitButtonText'>How To Use</span> */}
                  <span className='portraitButtonText'>{uiDataList.ui?.howToUSE}</span>
               </div>

               {/* <div id="howToUseMenu" tabIndex="1" className='menu noDropDown HowToUseHeader' onClick={data1.method2} onKeyDown={(e) => {
                  if (e.key !== 'Enter') {
                     return
                  } howToUSEClick()
               }}>
                  <div className='icon howtouse'> </div>
                  <div className='text'>How to use</div>
               </div> */}

               <div id="howToUseMenu" tabIndex="1" className='menu noDropDown HowToUseHeader' onClick={data1.method2} onKeyDown={(e) => { if (e.key !== 'Enter') { return } howToUSEClick() }}>
                  <div className='icon howtouse'> </div>
                  <div className='text'>{howToUSE !== undefined ? howToUSE : 'How to use'}</div>
               </div>

               {/* {orentation === 0 ? <Howtousenew /> : <HowToUse closeHandle={closeHandle} />} */}
               {orentation === 0 ? <Howtousenew data={uiDataList.ui} /> : <HowToUse data={uiDataList.ui} closeHandle={closeHandle} />}
               {/* <div className='accordionContainer'> */}
               <div className={window.mob || (window.isipad && window.innerWidth < window.innerHeight) ? 'accordionContainer relative d-flex' : 'accordionContainer relative '}>
                  {
                     menuList.map((list) => {

                        return (
                           <React.Fragment key={list.id}>
                              {list.id === 'btnXR-ipad' && window.isipad && orentation === 90 ?
                                 <div id={`btnXR-ipad`} tabIndex="1" className='menu' key={list.id} >
                                    <div className={`icon ${list.id}`} ></div>
                                    <div className='text'>{list.title} {list.title}</div>
                                 </div> : list.id !== 'btnXR-ipad' && <div id={`accordion_${list.id}`} tabIndex="1" className='menu' onClick={data1.method} onKeyDown={(e) => {
                                    if (e.key !== 'Enter') {
                                       return
                                    } accordionMenu(e)
                                 }}>
                                    <>
                                       <div className={`icon ${list.id}`} style={{ backgroundImage: `url('${list.icon}')` }}></div>
                                       <div className={`mob_icon mob_icon_${list.id}`}></div>
                                       <div className='text'>{(!window.mob && window.innerWidth > window.innerHeight) && orentation === 90 ? list.title : list.mobileTitle}</div>
                                       <div className='dds__side-nav__group__chevron'><svg viewBox="0 0 32 32" className="dds__side-nav__group__chevron" aria-hidden="true" focusable="false"><path d="M30.48 7.24l-14.48 14.48-14.48-14.48-1.52 1.52 16 16 16-16z"></path></svg></div>
                                    </>
                                 </div>
                              }
                              {list.items && list.items.menuVisibility !== "hide" && <SubmenuList subMenuList={list.items} orentation={orentation} handleMenuClick={handleMenuClick} />}
                           </React.Fragment>
                        )
                     })

                  }
               </div>
               <div id="menuFooter">
               {myJson.QRSupport && <div id="qrCode">
                     <img src='images/qrcode.svg' /> <br />
                     <span className='text'>{QR !== undefined ? QR : 'Scan QR code with your mobile device to view the product in your space'}</span>
                  </div>
                  }
                  <div id="animation">
                     {/* <span>Reduce Transitions </span> */}
                     <span>{ReduceTransitions !== undefined ? ReduceTransitions : 'Reduce Transitions'}</span>
                     <label className="switch" tabIndex="1" id="animswtich" onKeyPress={handleTransitionskeyPress} >
                        <input tabIndex="-1" className="tabIndexStyle" name='animationOnOff' id="animSwitchValue" type="checkbox" onChange={handleTransitions} defaultChecked={true} />
                        <span className="tabIndexStyle slider round" ></span>
                        <span className="onOff"></span>
                     </label>
                  </div>
                  {ReactDOM.createPortal(
                     <div id="onScreenControl" className='tooltip'>
                        {/* <span className=''>On-Screen Controls
                           <span className="tooltiptext">Click to toggle controls on/off</span>
                        </span> */}
                        <span className=''>{onScreenControls !== undefined ? onScreenControls : 'On-Screen Controls'}
                           <span className="tooltiptext">{hovertext !== undefined ? hovertext : 'Click to toggle controls on/off'}</span>
                        </span>
                        <label className="switch" tabIndex="1" id="onScreenControls" onKeyPress={conScreenControlHandlerkeyPress}>
                           <input tabIndex="-1" className="tabIndexStyle" name='animationOnOff' id="onScreenControlsValue" type="checkbox" onChange={conScreenControlHandler} />
                           <span className="tabIndexStyle slider round" ></span>
                           <span className="onOff"></span>
                        </label>
                     </div>, document.getElementById('onScreenControlContainer'))}
               </div>
               <button className='expandColapsBtn' onClick={menuExpandCollaps}></button>
            </div>
            {/* <FooterControl onPrevious={onPreviousMode} onNext={onNextMode} onReset={onReset} closeHandle={closeHandle} /> */}
            <FooterControl data={uiDataList.ui} onPrevious={onPreviousMode} onNext={onNextMode} onReset={onReset} closeHandle={closeHandle} />
         </div>
      </>
   );
}

export default Menu;